import stripHtml from 'src/app/data/common/utils/stripHtml';
import renderSanitizedContent from 'src/app/data/common/utils/renderSanitizedContent';

const regexForMatchHtml = /(<([^>]+)>)/gi;

/**
 * Renders an HTML string into a div. The HTML is sanitized with DOMPurify
 * (via renderSanitizedContent) before being injected, so stored markup cannot
 * execute scripts/event handlers when displayed.
 */
export const getPlainText = (val: string, className?: string) => {
  return renderSanitizedContent(val, className);
};

export const extractLengthFromHtmlData = (val: string) => {
  return stripHtml(val).trim().length;
};

export const extractTextFromHtmlData = (val: string) => {
  return val.replace(regexForMatchHtml, "");
};
